<template>
    <div class="l2-feature-showcase" :style="{ '--l2-feature-accent': props.accent } as Record<string, string>">
        <h3 class="l2-feature-showcase__title" :style="`color: ${accent}`">{{ props.title }}</h3>
        <ul class="l2-feature-showcase__list">
            <li v-for="bullet in props.bullets" :key="bullet">
                {{ bullet }}
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        title: string;
        bullets: string[];
        accent: string;
    }>();
</script>

<style lang="scss" scoped>
    .l2-feature-showcase {
        position: relative;
        border-radius: 18px;
        background: transparent;
        border: 0;
        overflow: hidden;

        //&::before {
        //    content: '';
        //    position: absolute;
        //    inset: 0;
        //    background: radial-gradient(ellipse 70% 60% at 20% 0%, color-mix(in srgb, var(--l2-feature-accent) 10%, transparent), transparent 60%);
        //    opacity: 0.35;
        //    pointer-events: none;
        //}
        //
        //&::after {
        //    content: '';
        //    position: absolute;
        //    inset: 0;
        //    border-radius: inherit;
        //    pointer-events: none;
        //}

        @media (min-width: 600px) {
            filter: drop-shadow(0 26px 46px rgba(15, 23, 42, 0.12));
        }

        &__title {
            position: relative;
            z-index: 1;
            margin: 0 0 14px;
            font-size: 1.25rem;
            font-weight: 700;
            line-height: 1.2;
            color: var(--landing-text);
        }

        &__list {
            position: relative;
            z-index: 1;
            margin: 0;
            padding: 0;
            list-style: none;
            display: flex;
            flex-direction: column;
            gap: 10px;
            color: var(--landing-text);
            font-size: 0.98rem;
            line-height: 1.65;

            li {
                position: relative;
                padding-left: 22px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0.65em;
                    width: 10px;
                    height: 10px;
                    border-radius: 999px;
                    background: var(--l2-feature-accent);
                    box-shadow: 0 0 24px color-mix(in srgb, var(--l2-feature-accent) 35%, transparent);
                    transform: translateY(-50%);
                }
            }
        }
    }
</style>
